import * as ActionTypes from "../Types/ActionTypes";

const initialState = {
  branchCaseCount: {
    isLoading: false,
    data: null,
    error: null,
  },
};

const branchCaseCount = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.BRANCH_CASE_COUNT_LOADING:
      return {
        ...state,
        branchCaseCount: {
          ...state.branchCaseCount,
          isLoading: true,
          error: null,
        },
      };
    case ActionTypes.FETCH_BRANCH_CASE_COUNT:
      return {
        ...state,
        branchCaseCount: {
          ...state.branchCaseCount,
          isLoading: false,
          data: action.payload,
          error: null,
        },
      };
    case ActionTypes.BRANCH_CASE_COUNT_FAILED:
      return {
        ...state,
        branchCaseCount: {
          ...state.branchCaseCount,
          isLoading: false,
          error: action.payload,
          data: null,
        },
      };
    default:
      return state;
  }
};

export default branchCaseCount;